import { Component, inject } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MaterialModule } from 'src/app/shared/material/material.module';
import { DEFAULT_ALERT_CONFIG } from 'src/app/configuration/configuration.defaults';
import { LocationProvider } from '../patient.model';
import { FormUtils } from 'src/app/shared/utils/form-utils';

@Component({
  selector: 'app-add-person-dialog',
  standalone: true,
  imports: [MaterialModule, ReactiveFormsModule],
  templateUrl: './add-person-dialog.component.html',
  styleUrl: './add-person-dialog.component.scss',
})
export class AddPersonDialogComponent {
  #dialogRef = inject(MatDialogRef<AddPersonDialogComponent>);
  #data: { locations: LocationProvider[]; subjectLabel?: string } = inject(MAT_DIALOG_DATA);
  form = new FormGroup({
    name: new FormControl('', [
      Validators.required,
      Validators.pattern(/^[a-zA-Z0-9].*$/),
      Validators.minLength(3),
    ]),
    phone: new FormControl('', [Validators.pattern(/^\(\d{3}\)\s\d{3}-\d{4}$/)]),
    location: new FormControl<LocationProvider | ''>('', [Validators.required]),
  });
  locations: LocationProvider[] = this.#data.locations ?? [];
  subjectLabel = this.#data.subjectLabel?.trim() || DEFAULT_ALERT_CONFIG.subjectLabel;

  getNameErrorMessage() {
    if (this.name.hasError('required')) {
      return 'You must enter a name';
    } else if (this.name.hasError('pattern')) {
      return 'You must enter a valid name';
    } else if (this.name.hasError('minlength')) {
      return 'Name must be at least 3 characters';
    }
    return 'You must enter a valid name';
  }

  getPhoneErrorMessage() {
    if (this.phone.hasError('pattern')) {
      return 'You must enter a valid phone number';
    }
    return '';
  }

  get name() {
    return this.form.controls.name;
  }
  get phone() {
    return this.form.controls.phone;
  }

  onSubmit() {
    if (this.form.invalid) {
      return;
    }
    this.#dialogRef.close(this.form.value);
  }

  public handleKeyUp(event: KeyboardEvent): void {
    if (event.key === 'Enter' && this.form.valid) {
      this.onSubmit();
    } else {
      if (this.phone.value) this.phone.setValue(FormUtils.formatPhoneNumber(this.phone.value));
    }
  }
}
